


























































































































import Vue from 'vue'
import NotificationSetting, {
    NotificationSettingDetail,
    NotificationToggle
} from '@/types/NotificationSetting.interface'
import { mapGetters } from 'vuex'
import LoadingMask from '@/components/LoadingMask.vue'
import NotificationSettingDetailComponent from '@/components/NotificationSettingDetail.vue'
export default Vue.extend({
    components: {
        LoadingMask,
        'notification-setting-detail': NotificationSettingDetailComponent
    },
    data() {
        return {
            generalNotification: {
                email: true,
                push: true,
                browser: true
            },
            loading: false,
            messageNotification: {
                email: true,
                push: true,
                browser: true
            },
            showMore: false
        }
    },
    computed: {
        ...mapGetters([
            'browserNotifications',
            'currentMembership',
            'emailNotifications',
            'isApp',
            'productTier',
            'pushNotifications',
            'tenantMemberships'
        ]),
        generalSetting(): object {
            //  If there is no current membership. return null
            if (
                !this.emailNotifications ||
                !this.pushNotifications ||
                !this.browserNotifications
            )
                return null

            // Check if our enabled matches the total
            const email = this.totalNotifications('email')
            const push = this.totalNotifications('push')
            const browser = this.totalNotifications('browser')

            //  Return the total setting
            return { email: email, push: push, browser: browser }
        },
        messageSetting(): object {
            //  If there is no current membership. return null
            if (!this.currentMembership) return null

            //  Else, search their email notifications for all notifications that have module 'messages'
            const email = this.currentMembership.email_notifications.messages.enabled

            //  Get all push notifications for messages
            const push = this.currentMembership.push_notifications.messages.enabled

            //  Get all browser notifications for messages
            const browser = this.currentMembership.browser_notifications.messages.enabled

            //  Return the total setting
            return { email: email, push: push, browser: browser }
        }
    },
    methods: {
        //  Check browser notification permission
        checkNotificationPromise() {
            try {
                Notification.requestPermission().then()
            } catch (e) {
                return false
            }
            return true
        },
        goToBrowserNotifications(): void {
            //  Have the browser ask for notification permission
            this.checkNotificationPromise()

            //  Get the current status of browser notifications
            const s = Notification.permission === 'granted' ? 'enabled' : 'disabled'

            //  Assemble the message text
            const text = `Browser notifications must be enabled/disabled in your browser settings. Steps to enable/disable these will vary by browser. Your browser notifications are currently ${s}`

            //  Pop a message
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Browser Notifications',
                text: text,
                icon: 'mdi-web',
                color: 'primary'
            })
        },
        switchGeneral(bool: boolean, type: string) {
            //  Toggle our sets
            this.toggleAllNotifications(bool, type)

            //  Construct our type selector
            const selector = `${type}_notifications`

            //  Grab all of our keys
            const keys = Object.keys(this.currentMembership[selector])

            //  Iterate through our keys
            for (let i = 0; i < keys.length; i++) {
                //  If the key is NOT messages, then set the enabled
                if (keys[i] !== 'messages')
                    this.currentMembership[selector][keys[i]].enabled = bool
            }
        },
        switchMessage(bool: boolean, type: string) {
            //  Toggle our sets
            this.toggleAllNotifications(bool, type, true)

            //  Construct our type selector
            const selector = `${type}_notifications`

            //  Update our overall
            this.currentMembership[selector].messages.enabled = bool
        },
        async submit(): Promise<void> {
            //  Our payload is just the current membership
            const payload = this.currentMembership

            //  Start the loading spinner
            this.loading = true

            //  Send our request
            const response = await this.$store.dispatch('tenantMembershipsPut', payload)

            //  Stop the loading spinner
            this.loading = false

            //  If the request failed, do nothing
            if (!response) return

            //  Check if browser settings were checked
            const browser = this.generalSetting.browser || this.messageSetting.browser

            //  If browser is checked for any of them, notify the user IF they are not on mobile
            if (browser && !this.isApp) this.goToBrowserNotifications()

            //  Else, close our dialog
            this.$emit('submit')
        },
        toggleAllNotifications(
            bool: boolean,
            type: string,
            message: boolean = false
        ): void {
            //  Iterate through our type of notification
            this[`${type}Notifications`].forEach(
                (item: NotificationSetting, idx: number) => {
                    //  Reference to our category
                    const category = item.category

                    //  If message is true, we skip if module is not message
                    if (message && item.category !== 'messages') return
                    //  Else, if message is FALSE, we skip if module IS message
                    else if (!message && item.category === 'messages') return

                    //  Iterate through our items for this module
                    item.items.forEach((n: NotificationSettingDetail, nIdx: number) => {
                        //  Create our selector on our current membership
                        const selector = `${type}_notifications`

                        //  Our notifications based on selector
                        const notifs = this.currentMembership[selector]

                        //  Check if this notificaiton exists
                        if (notifs[category].items[n.id]) {
                            //  If it exists, then set it
                            this.currentMembership[selector][category].items[
                                n.id
                            ].enabled = bool
                        }
                        //  Set our display as well
                        this[`${type}Notifications`][idx].items[nIdx].enabled = bool
                    })
                }
            )
        },
        toggleNotification(obj: NotificationToggle): void {
            //  Toggle based on this deep selector
            this.currentMembership[`${obj.type}_notifications`][obj.category].items[
                obj.key
            ].enabled = obj.val
        },
        totalNotifications(type: string, message: boolean = false): boolean {
            //  Grab our notifications for this type
            const notifs = this[`${type}Notifications`]

            //  Get a filtered amount to only include enabled categories
            const filtered = notifs.filter((x) => {
                //  If message is false, then we let this pass if category is messages
                if (!message && x.category === 'messages') return true

                //  Else, we have to filter the items
                const total = x.items.filter((y) => {
                    //  Check for the enabled flag
                    return y.enabled
                })

                //  If our total length is greater than 0, return true
                return total.length > 0
            })

            //  This is true if our filtered amount is equivalent to the base
            return filtered.length === notifs.length
        }
    }
})
